import { Box, styled } from '@mui/material';
import {
  APPROVAL_SECTION_GAP,
  InfoSectionTitle,
} from '@/components/Approval/@components/InfoSection';
import { APPROVAL_TABLE_HEAD_BG } from '@/components/Approval/@components/ApprovalFormTable/styles';

export const ProductionCostRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${APPROVAL_SECTION_GAP}px;

  & .approval-form-table td {
    text-align: center;
  }
  & .approval-form-table td.align-right {
    text-align: right;
  }
  & .approval-form-table td.align-left {
    text-align: left;
  }
  /* 공통 표의 break-all 보다 우선해야 영문 머리글·구분이 단어 중간에서 안 끊김 */
  & .approval-form-table th,
  & .approval-form-table td {
    word-break: keep-all;
    overflow-wrap: anywhere;
  }
  /* 레거시 통화키 열 — 표 폭의 18%, 최대 200px. col 은 min() 의 % 를 못 풀어 넓은 화면은 200px 고정 */
  & .col-currency {
    width: 200px;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    & .col-currency {
      width: 18%;
    }
  }
  & .row-summary td,
  & .row-total td {
    background-color: ${APPROVAL_TABLE_HEAD_BG};
  }
  & .row-summary td.align-right,
  & .row-total td.align-right {
    font-weight: 600;
  }
  & .approval-form-table td.note-input {
    padding: 0;
  }
`;

export const ProductionCostSection = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProductionCostTitle = styled(InfoSectionTitle)``;

export const ProductionCostDescription = styled('p')`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--dk-text, #131313);

  &.description {
    color: var(--dk-text-sub, #6b7280);
  }
`;
